import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatButton } from '@blocks-react/components/Button';

type CatButtonProps = ComponentProps<typeof CatButton> & { ariaLabel?: string };

export const MyEquipmentButton: FC<PropsWithChildren<CatButtonProps>> = ({
  children,
  ...buttonProps
}) => <CatButton {...buttonProps}>{children}</CatButton>;
